module.exports = new __parcel__URL__("base_raid_next_btn.47c6bbe4.png").toString();